import { useEffect } from "react";
import Quill from "quill";

function CommentWidget(props) {
  const { text_content } = props;
  const id = `${props.lesson_module_name}${props.id}`;
  useEffect(() => {
    const q = new Quill(`#${id}`, {
      modules: {
        toolbar: [
          [{ header: [1, 2, false] }]
        ]
      },
      theme: 'bubble',
    });
    q.enable(false);
    if (
      q.setContents &&
      (text_content && text_content.length > 0)
    ) {
      q.setContents(JSON.parse(text_content));
    }
  }, [text_content])

  return (
    <div className="EmployeeReaderWidget EmployeeReaderCommentWidget">
      <div id={id} />
    </div>
  )
}

export { CommentWidget };
